"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const INotificationEvent_1 = require("../../models/notifications/INotificationEvent");
const NotificationMethodNames_1 = require("../../models/notifications/NotificationMethodNames");
const notificationEventNames = Object.values(INotificationEvent_1.NotificationEventName);
exports.default = joi_1.default.object({
    event: joi_1.default.object({
        eventName: joi_1.default.string()
            .valid(...notificationEventNames)
            .required(),
        days: joi_1.default.number().optional(),
    }).required(),
    methods: joi_1.default.object({
        [NotificationMethodNames_1.NotificationMethodNames.Email]: joi_1.default.object({
            enabled: joi_1.default.boolean().required(),
            addresses: joi_1.default.array().items(joi_1.default.string()).required(),
        }),
        [NotificationMethodNames_1.NotificationMethodNames.SMS]: joi_1.default.object({
            enabled: joi_1.default.boolean().required(),
            phoneNumbers: joi_1.default.array().items(joi_1.default.string()).required(),
        }),
        [NotificationMethodNames_1.NotificationMethodNames.InApp]: joi_1.default.object({
            enabled: joi_1.default.boolean().required(),
            userIds: joi_1.default.array().items(joi_1.default.string()).required(),
        }),
    }).required(),
});
